import React from "react"
import { Bounds } from "../grid"

import { SwitchContainer } from "./styled"
import { YekanParagraph } from "../../components/typography"

class PriceSwitch extends React.Component {
  constructor() {
    super()
    this.state = {
      step: 0,
    }
  }

  handleSwitch = e => {
    const { handleSwitch } = this.props
    const { value } = e.target
    const intVal = parseInt(value, 10)
    console.log("switch value", e.target.value)
    handleSwitch(intVal)
    this.setState({ step: intVal })
  }

  render() {
    const { labels, switchText } = this.props
    const { step } = this.state

    return (
      <Bounds valign="center" halign="center" direction="vertical">
        <YekanParagraph>{switchText}</YekanParagraph>
        <SwitchContainer step={step} steps={labels.length}>
          {labels.map((label, index) => {
            const id = `choice_${index}`
            return (
              <div key={`${label}_${index}`} className="option">
                <input
                  type="radio"
                  id={id}
                  value={index}
                  name="priceSwitch"
                  onClick={this.handleSwitch}
                />
                <YekanParagraph as="label" htmlFor={id}>
                  {label}
                </YekanParagraph>
              </div>
            )
          })}
          <span className="slider" />
        </SwitchContainer>
      </Bounds>
    )
  }
}

export default PriceSwitch
